import "./Stories.css";

import React, { useState } from "react";
import { getBtnColor, getBtnText, getUpdateStatus } from "../../helper";

import StoryTabs from "./components/StoryTabs";
import { epochToDateString } from "../../../../helper";
import { selectUser } from "../../../../redux/reducers/userReducer";
import { useSelector } from "react-redux";

// Matches the backend's staleness window: a presence claim older than this
// is treated as expired (closed laptop, crashed tab).
const PRESENCE_STALE_MS = 2 * 60 * 1000;

const TABS = [
  {
    title: "My Stories",
    value: "my_stories",
  },
  {
    title: "Editing",
    value: "pending_approvals",
  },
];

// Persisted so returning from the story editor lands on the tab the editor
// came from (e.g. Editing) instead of resetting to My Stories.
const TAB_STORAGE_KEY = "adminStoriesSelectedTab";

function Stories({
  createStoryClick,
  allStoriesData,
  allInDevsStories,
  allApprovedRejectedStories,
  handleDeleteStory,
  storyDetailsClick,
  updateStoryStatusToServer,
  makeLeadClick,
}) {
  const user = useSelector(selectUser);
  const myEmail = user.data?.user.user_id || "";

  // Someone ELSE with a live claim on the story (own claims show nothing).
  const getActiveHolder = (story) =>
    story.editingBy &&
    story.editingBy !== myEmail &&
    story.editingAt &&
    Date.now() - story.editingAt._seconds * 1000 < PRESENCE_STALE_MS
      ? {
          name: story.editingByName || story.editingBy,
          activity: story.editingActivity || "editing",
        }
      : null;

  const confirmIfHeld = (story) => {
    const holder = getActiveHolder(story);
    return (
      !holder ||
      window.confirm(
        `${holder.name} is ${holder.activity} this story right now — open anyway?`
      )
    );
  };

  const [selectedtab, setSelectedTabState] = useState(
    sessionStorage.getItem(TAB_STORAGE_KEY) || TABS[0].value
  );
  const setSelectedTab = (tab) => {
    sessionStorage.setItem(TAB_STORAGE_KEY, tab);
    setSelectedTabState(tab);
  };

  const getDataToRender = () => {
    switch (selectedtab) {
      case TABS[0].value:
        return allStoriesData;
      case TABS[1].value:
        return allInDevsStories;
      default:
        return allStoriesData;
    }
  };

  const handleWriteStoryClick = () => {
    createStoryClick();
  };

  const showAuthorColumn = selectedtab !== TABS[0].value;
  const showActionBtn = selectedtab === TABS[1].value;

  const renderStutusView = (status) => {
    return status;
  };

  return (
    <div className="admin-stories">
      <div className="header-container">
        <h2
          style={{
            color: "#161616",
            fontSize: 24,
            fontFamily: "Nunito Sans",
            fontWeight: 700,
          }}
        >
          My Stories
        </h2>
        <button className="write-story-btn" onClick={handleWriteStoryClick}>
          Write Story
        </button>
      </div>
      <StoryTabs
        tabs={TABS}
        selectedtab={selectedtab}
        setSelectedTab={setSelectedTab}
      />
      <table style={{ marginTop: 10 }}>
        <thead>
          <tr
            style={{
              color: "#667085",
              fontSize: 14,
              fontFamily: "Nunito Sans",
              fontWeight: 400,
            }}
          >
            <th>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span> Story Name</span>
                <img
                  src="./assets/arrowdown.svg"
                  alt="arrowDown"
                  style={{
                    marginLeft: 5,
                  }}
                />
              </div>
            </th>
            <th>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span> Creation Date</span>
                <img
                  src="./assets/arrowdown.svg"
                  alt="arrowDown"
                  style={{
                    marginLeft: 5,
                  }}
                />
              </div>
            </th>
            {showAuthorColumn && (
              <th>
                <div style={{ display: "flex", alignItems: "center" }}>
                  Briefings
                  <img
                    src="./assets/arrowdown.svg"
                    alt="arrowDown"
                    style={{
                      marginLeft: 5,
                    }}
                  />
                </div>
              </th>
            )}
            {showAuthorColumn && <th>Author</th>}
            <th>Story Type</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {getDataToRender().map((story) => (
            <tr key={story.id}>
              <td
                style={{
                  color: "#161616",
                  fontSize: 14,
                  fontFamily: "Nunito Sans",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (showActionBtn && confirmIfHeld(story)) {
                    storyDetailsClick(story);
                  }
                }}
              >
                {story.heading}
                {(() => {
                  const holder = getActiveHolder(story);
                  return holder ? (
                    <div
                      style={{
                        display: "inline-block",
                        marginLeft: 8,
                        padding: "1px 8px",
                        borderRadius: 10,
                        background: "#FFF4E5",
                        border: "1px solid #F0B429",
                        color: "#8A5A00",
                        fontSize: 11,
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {holder.activity === "reviewing" ? "👀" : "✏️"}{" "}
                      {holder.name} is {holder.activity}
                    </div>
                  ) : null;
                })()}
              </td>
              <td
                style={{
                  color: "#667085",
                  fontSize: 14,
                  fontFamily: "Nunito Sans",
                  fontWeight: 400,
                }}
              >
                {epochToDateString(story?.createdAt?._seconds)}
              </td>
              {showAuthorColumn && (
                <td
                  style={{
                    color: "#667085",
                    fontSize: 14,
                    fontFamily: "Nunito Sans",
                    fontWeight: 400,
                  }}
                >
                  {"2024-05-29 07:07"}
                </td>
              )}
              {showAuthorColumn && (
                <td
                  style={{
                    color: "#667085",
                    fontSize: 14,
                    fontFamily: "Nunito Sans",
                    fontWeight: 400,
                  }}
                >
                  {story.name || story.email}
                </td>
              )}
              <td
                style={{
                  color: "#667085",
                  fontSize: 14,
                  fontFamily: "Nunito Sans",
                  fontWeight: 400,
                }}
              >
                {story.type}
                {showActionBtn &&
                  story.storyType !== "column" &&
                  (story.type === "public" ? (
                    <span
                      style={{
                        marginLeft: 8,
                        color: "#0b335e",
                        fontWeight: 700,
                        fontSize: 12,
                      }}
                    >
                      ★ Lead
                    </span>
                  ) : (
                    <button
                      onClick={() => makeLeadClick(story)}
                      title="Make this the lead (public) story of its briefing"
                      style={{
                        marginLeft: 8,
                        padding: "2px 10px",
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#0b335e",
                        border: "1px solid #0b335e",
                        borderRadius: 12,
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      Make lead
                    </button>
                  ))}
              </td>
              <td
                style={{
                  color: "#667085",
                  fontSize: 14,
                  fontFamily: "Nunito Sans",
                  fontWeight: 400,
                }}
              >
                {renderStutusView(story.status)}
              </td>
              <td>
                <div className="story-actions">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (confirmIfHeld(story)) {
                        createStoryClick(story);
                      }
                    }}
                  >
                    <img src="./assets/Edit.svg" alt="edit" />
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleDeleteStory(story);
                    }}
                  >
                    <img src="./assets/delete.svg" alt="delete" />
                  </span>
                </div>
              </td>
              {showActionBtn && (
                <td>
                  <button
                    style={{
                      padding: "4px 0px",
                      color: getBtnColor(story.status),
                      border: "1.5px solid",
                      borderRadius: "20px",
                      minWidth: "120px",
                      fontSize: "10px",
                      fontWeight: "bold",
                    }}
                    className="save-a-Briefing"
                    onClick={() => {
                      updateStoryStatusToServer(
                        story,
                        getUpdateStatus(story.status),
                      );
                    }}
                  >
                    {getBtnText(story.status)}
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Stories;
